import * as React from 'react';
import { observer } from 'mobx-react';
import Books from '../../../../../../Cutesies/Books';
import { T } from '../../../../../../../Translations';

const Header: React.FC = () => (
  <div className="pt-8">
    <h3 className="flex flex-row items-center gap-2 px-11 py-4 text-xl font-semibold">
      <Books />
      <T kind="Program Catalog" />
    </h3>
  </div>
);

export default observer(Header);
